import { render, staticRenderFns } from "./ContentBlockForm.vue?vue&type=template&id=6985a655&scoped=true&"
import script from "./ContentBlockForm.vue?vue&type=script&lang=js&"
export * from "./ContentBlockForm.vue?vue&type=script&lang=js&"
import style0 from "./ContentBlockForm.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ContentBlockForm.vue?vue&type=style&index=1&id=6985a655&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6985a655",
  null
  
)

export default component.exports